import Lottie from "lottie-react";
import CompleteAnimation from "./CompleteAnimation.json";
import CustomButton from "../../../common/CustomButton";

function AfterPurchaseMessage({onClick}) {
    return (
        <div id="sp-after-purchase-message">
            <div id="sp-apm-icon-wrapper">
                <div id="sp-apm-icon">
                    <Lottie
                        id="sp-apm-icon-animation"
                        animationData={CompleteAnimation}
                        loop={true}
                    />

                    <div id="sp-apm-icon-bg-floater" />
                </div>

                <div id="sp-apm-text">
                    <h3>All Set! Let’s</h3>
                    <h3>Get Moving!</h3>
                </div>

                <CustomButton onClick={onClick}>Continue to Indi</CustomButton>
            </div>
        </div>
    );
}

export default AfterPurchaseMessage;
